<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'saleControl',
  props: ['value'],
  data() {
    return {
      model: {},
      fetch_sale: false
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('saleInvoiceStore', ['saleEmployees']),
    employeeList() {
      return this.saleEmployees.map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    }
  },
  methods: {
    ...mapActions('saleInvoiceStore', ['onGetSale']),
    handleSaleSearch: debounce(function(value) {
      this.fetch_sale = true
      this.onGetSale(value).finally(() => (this.fetch_sale = false))
    }, 500)
  }
}
</script>

<template>
  <div>
    <label class="required ts-mb-0">{{ $t('saleInvoice.saler') }}</label>
    <a-select
      show-search
      style="width: 100%"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="null"
      :loading="fetch_sale"
      @search="handleSaleSearch"
      v-model="model.seller_id"
      :options="employeeList"
      class="ts-w-full"
    ></a-select>
  </div>
</template>
